import React, { useCallback, useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import { Product } from "../../types/interfaces/Product";
import { callApi } from "../../modules/core/api/services";
import { API_URL } from "modules/core/api/constants";
import PricingSection from "../../components/PricingSection/PricingSection";
import { LoaderFullscreen } from "../../modules/core/components";

export const Pricing = () => {
  const [products, setProducts] = useState<Product[]>();

  useEffect(() => {
    if (!window.location.href.includes('home'))
      document.title = `Pricing | Staidium`;
  }, []);

  const getProducts = useCallback(async () => {
    const products = await callApi(
      `/v2/products?page=1&per_page=10&exclude_category=single_event_pass`
    );

    setProducts(products.data);
    return;
  }, [API_URL]);

  useEffect(() => {
    const fetchData = async () => {
      await getProducts();
    };

    fetchData();
  }, [getProducts]);

  if (!products) return <LoaderFullscreen />;

  return (
    <>
      <Breadcrumb title="Available Passes" />
      <div
        className="static-page"
        style={{ paddingBottom: "0px", paddingTop: "0px" }}
      >
        <PricingSection panels={products ? products : []} />
      </div>
    </>
  );
};
